export default __webpack_public_path__ + "static/media/social-facebook.2d39a1f5.svg";